// extracted by mini-css-extract-plugin
module.exports = {"root":"MatchesBlock_root__quEAj","iconWrap":"MatchesBlock_iconWrap__Ucxdl","greenIcon":"MatchesBlock_greenIcon__G9Abq","title":"MatchesBlock_title__T_eUU"};